var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAgentImages = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "m1",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 0,
  width: 20,
  height: 24
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 0H2V14C2 11.7909 3.79086 10 6 10H12C14.2091 10 16 11.7909 16 14V20C16 22.2091 14.2091 24 12 24H22V0Z",
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#m1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 10.75C11.4142 10.75 11.75 11.0858 11.75 11.5V12.5155C12.6547 12.6283 13.3717 13.3453 13.4845 14.25H14.5C14.9142 14.25 15.25 14.5858 15.25 15C15.25 15.4142 14.9142 15.75 14.5 15.75H13.5V18.25H14.5C14.9142 18.25 15.25 18.5858 15.25 19C15.25 19.4142 14.9142 19.75 14.5 19.75H13.4845C13.3717 20.6547 12.6547 21.3717 11.75 21.4845L11.75 22.5C11.75 22.9142 11.4142 23.25 11 23.25C10.5858 23.25 10.25 22.9142 10.25 22.5V21.5H7.75V22.5C7.75 22.9142 7.41421 23.25 7 23.25C6.58579 23.25 6.25 22.9142 6.25 22.5V21.4845C5.34532 21.3717 4.62829 20.6547 4.51547 19.75H3.5C3.08579 19.75 2.75 19.4142 2.75 19C2.75 18.5858 3.08579 18.25 3.5 18.25H4.5V15.75H3.5C3.08579 15.75 2.75 15.4142 2.75 15C2.75 14.5858 3.08579 14.25 3.5 14.25H4.51547C4.62829 13.3453 5.34532 12.6283 6.25 12.5155V11.5C6.25 11.0858 6.58579 10.75 7 10.75C7.41421 10.75 7.75 11.0858 7.75 11.5V12.5H10.25V11.5C10.25 11.0858 10.5858 10.75 11 10.75ZM11.5 13.8H6.5C6.1134 13.8 5.8 14.1134 5.8 14.5V19.5C5.8 19.8866 6.1134 20.2 6.5 20.2H11.5C11.8866 20.2 12.2 19.8866 12.2 19.5V14.5C12.2 14.1134 11.8866 13.8 11.5 13.8Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  x: 7.5,
  y: 15.5,
  width: 3,
  height: 3,
  rx: 0.5,
  fill: "currentColor"
}))));
export default SvgAgentImages;